module.exports = __webpack_public_path__ + "img/b148d64b4e3a1acff84987f512a4f203.png";